import React from 'react';
import { string } from 'prop-types';

import classnames from 'classnames';

import { BuildIcon } from '../utils';

const namespace = 'ui-search-icon ui-search-icon--search';

const IconSearch = (props) => (
  <BuildIcon {...props} className={classnames(namespace, props.className)} viewBox="0 0 22 22">
    <path d="M8.497.25a8.247 8.247 0 016.337 13.525L20.061 19 19 20.06l-5.225-5.226A8.247 8.247 0 118.497.25zm0 1.5a6.747 6.747 0 100 13.494 6.747 6.747 0 000-13.494z" />
  </BuildIcon>
);

IconSearch.propTypes = {
  className: string,
};
IconSearch.defaultProps = {
  className: null,
};

export default IconSearch;
